export default {
  lang: '繁體中文',
  // QQ表情
  "qqface_Smile": "微笑",
  "qqface_Grimac": "憋嘴",
  "qqface_Drool": "色",
  "qqface_Scowl": "發呆",
  "qqface_Chill": "得意",
  "qqface_Sob": "流淚",
  "qqface_Shy": "害羞",
  "qqface_Silent": "閉嘴",
  "qqface_Sleep": "睡",
  "qqface_Cry": "大哭",
  "qqface_Awkward": "尷尬",
  "qqface_Angry": "發怒",
  "qqface_Tongue": "調皮",
  "qqface_Grin": "呲牙",
  "qqface_Surprise": "驚訝",
  "qqface_Frown": "難過",
  "qqface_CoolGuy": "酷",
  "qqface_Helpless": "冷汗",
  "qqface_Scream": "抓狂",
  "qqface_Puke": "吐",
  "qqface_Chuckle": "偷笑",
  "qqface_Joyful": "可愛",
  "qqface_Slight": "白眼",
  "qqface_Smug": "傲慢",
  "qqface_Hungry": "飢餓",
  "qqface_Drowsy": "困",
  "qqface_Panic": "驚恐",
  "qqface_Sweat": "流汗",
  "qqface_Laugh": "憨笑",
  "qqface_Commando": "大兵",
  "qqface_Determined": "奮鬥",
  "qqface_Scold": "咒罵",
  "qqface_Confused": "疑問",
  "qqface_Shhh": "噓...",
  "qqface_Dizzy": "暈",
  "qqface_Torturing": "折磨",
  "qqface_Toasted": "蓑",
  "qqface_Skull": "骷顱",
  "qqface_Hammer": "敲打",
  "qqface_Bye": "再見",
  "qqface_Speechless": "擦汗",
  "qqface_NosePick": "摳鼻",
  "qqface_Clap": "鼓掌",
  "qqface_Embarrased": "糗大了",
  "qqface_Trick": "壞笑",
  "qqface_Hum!L": "左哼哼",
  "qqface_Hum!R": "右哼哼",
  "qqface_Yawn": "哈欠",
  "qqface_Pooh-pooh": "鄙視",
  "qqface_Shrunken": "委屈",
  "qqface_TearingUp": "快哭了",
  "qqface_Sly": "陰險",
  "qqface_Kiss": "親親",
  "qqface_What!": "嚇",
  "qqface_Whimper": "可憐",
  "qqface_Cleaver": "菜刀",
  "qqface_Watermelon": "西瓜",
  "qqface_Beer": "啤酒",
  "qqface_Basketball": "籃球",
  "qqface_Pingpong": "乒乓",
  "qqface_Coffee": "咖啡",
  "qqface_Rice": "飯",
  "qqface_Pig": "豬頭",
  "qqface_Rose": "玫瑰",
  "qqface_Wilt": "凋謝",
  "qqface_Lips": "示愛",
  "qqface_Heart": "愛心",
  "qqface_BrokenHeart": "心碎",
  "qqface_Cake": "蛋糕",
  "qqface_Lightning": "閃電",
  "qqface_Bomb": "炸彈",
  "qqface_Knife": "刀",
  "qqface_Football": "足球",
  "qqface_Beetle": "瓢蟲",
  "qqface_Poop": "便便",
  "qqface_Moon": "月亮",
  "qqface_Sun": "太陽",
  "qqface_Gift": "禮物",
  "qqface_Hug": "擁抱",
  "qqface_Thumbsup": "強",
  "qqface_Thumbsdown": "弱",
  "qqface_Shake": "握手",
  "qqface_Victory": "勝利",
  "qqface_Salute": "抱拳",
  "qqface_Beckon": "勾引",
  "qqface_Fist": "拳頭",
  "qqface_Bad": "差勁",
  "qqface_LoveYou": "愛你",
  "qqface_NO": "NO",
  "qqface_OK": "OK",
  "qqface_Love": "愛情",
  "qqface_Blow_a_kiss": "飛吻",
  "qqface_Waddle": "跳跳",
  "qqface_Tremble": "發抖",
  "qqface_Aaagh!": "惱火",
  "qqface_Twirl": "轉圈",
  "qqface_Kowtow": "磕頭",
  "qqface_Turn_round": "回頭",
  "qqface_Rope_Skipping": "跳繩",
  "qqface_Wave_hand": "揮手",
  "qqface_Excited": "激動",
  "qqface_Street_Dance": "街舞",
  "qqface_Give_a_kiss": "獻吻",
  "qqface_Tai_Chi_L": "左太極",
  "qqface_Tai_Chi_R": "右太極",
  "qqface_Bliss": "雙喜",
  "qqface_Firecracker": "鞭炮",
  "qqface_Lantern": "燈籠",
  "qqface_Fortune": "發財",
  "qqface_Karaoke": "K歌",
  "qqface_Shopping": "購物",
  "qqface_Email": "郵件",
  "qqface_Handsome": "帥",
  "qqface_Hurray": "喝采",
  "qqface_Pray": "祈禱",
  "qqface_Furious": "爆筋",
  "qqface_Lollipop": "棒棒糖",
  "qqface_Drink_milk": "喝奶",
  "qqface_Noodles": "下面",
  "qqface_Banana": "香蕉",
  "qqface_Plane": "飛機",
  "qqface_Driving": "開車",
  "qqface_Highspeed_Rail_L": "高鐵左車頭",
  "qqface_Carriage": "车厢",
  "qqface_Highspeed_Rail_R": "高鐵右車頭",
  "qqface_Cloudy": "多雲",
  "qqface_Rainy": "下雨",
  "qqface_Cash": "鈔票",
  "qqface_Panda": "熊貓",
  "qqface_Light_bulb": "燈泡",
  "qqface_Windmill": "風車",
  "qqface_Alarm_Clock": "鬧鐘",
  "qqface_Umbrella": "大傘",
  "qqface_Balloon": "彩球",
  "qqface_Ring": "鑽戒",
  "qqface_Sofa": "沙發",
  "qqface_Toilet_Paper": "紙巾",
  "qqface_Medicine": "藥",
  "qqface_Pistol": "手槍",
  "qqface_Frog": "青蛙",
  "custom_Face": "自定義表情",
  // 通用UI展示信息
  "common_page_title": "線上咨詢",
  "common_sendbtn_text": "發送",
  "common_voicebtn_hold_text": "按住 說話",
  "common_voicebtn_release_text": "放開 發送",
  "common_voicebtn_cancel_text": "放開 取消",
  "common_insert_photo_text": "上傳圖片",
  "common_insert_emoji_text": "輸入表情",
  "common_manual_close_text": "結束會話",
  "common_insert_file_text": "上傳文件",
  "common_feed_back_text":"滿意度",
  "common_screenshot_text": '截圖',
  "common_screenshot_tip_QQ": "推薦使用QQ/微信截圖",
  "common_screenshot_tip_mac": 'Mac：快速鍵Shift+Command+4截圖',
  "common_screenshot_tip_win": 'Windows：使用自帶“截圖工具”',
  "short_insert_photo_text": "圖片",
  "short_insert_file_text": "文件",
  "common_insert_call_text": "音視頻通話",
  "common_insert_audo_text": "轉人工",
  "common_insert_businessCard_text": "發送名片",
  "common_insert_businessCard_balloon_text": "一鍵發送名片",
  "common_postarea_pc_placeholder": "請輸入，按Enter直接發送消息，Ctrl+Enter換行",
  "common_postarea_Macpc_placeholder": "請輸入，按Enter直接發送消息，Command+Enter換行",
  "common_postarea_mobile_placeholder": "請點擊輸入",
  "common_chatting_text": "交談中",
  "common_leave_message_text": "留言了",
  "common_chatting_with_text": "與$1交談中",
  "common_qq_chat_text": "去QQ交談",
  "common_start_qq_chat_text": "發起QQ會話",
  "common_new_message_text": "你有【新消息】",
  "common_add_qq_friend_text": "添加QQ聯絡人",
  "common_confirm_text": "確定",
  "common_cancel_text": "取消",
  "common_tencent_certification": "",
  "common_lang_en": "英語",
  "common_lang_zh": "簡體中文",
  "common_lang_zh-TW": "繁體中文",
  "common_tencent_translator": "騰訊翻譯君實時翻譯",
  "common_tencent_translator_fail": "翻譯失敗-騰訊翻譯君",
  "common_tencent_translator_only": "僅支持中英互譯-騰訊翻譯君",
  "common_allow_text": "允許",
  "common_not_allow_text": "不允許",
  "common_read_all": "閱讀全文",
  "common_typing": "正在輸入...",
  "common_view_all": "點擊查看全部",
  "common_audio_text": "音頻通話",
  "common_video_text": "視頻通話",
  "common_video_confirm": "我知道了",

  // 聊天相关信息
  "chat_max_post_limit_text": "發送消息過長，請分條發送。",
  "chat_history_msg_get_text": "點擊加載更多歷史消息",
  "chat_history_msg_get_error": "加載歷史消息失敗",
  "chat_history_msg_loading_text": "正在加載歷史消息",
  "chat_offline_msg_loading_text": "正在加載新消息",
  "chat_offline_msg_fail_text": "新消息加載失敗，點擊重試",
  "chat_offline_msg_over_text": "以下為未讀消息",
  "chat_menu_msg_loading_text": "正在加載菜單導航",
  "chat_menu_msg_fail_text": "菜單導航加載失敗，點擊重試",
  "chat_menu_msg_history_expired_text": "歷史紀錄已失效",
  "chat_graphic_msg_readmore_text": "閱讀原文",
  "chat_graphic_msg_viewdmore_text": "查看更多",

  "chat_feedback_title_text": "請為本次服務打分",
  "chat_feedback_submit_text": "提交",
  "chat_feedback_postarea_placeholder": "感謝您的評分，可留下其他意見或建議",
  "chat_feedback_submitting_text": "正在提交評價",
  "chat_feedback_success_msg": "提交成功",
  "chat_feedback_fail_msg": "提交失敗",
  "chat_feedback_error_msg": "網路錯誤，請重試",
  "chat_feedback_very_dissatisfied_text": "很不滿意",
  "chat_feedback_dissatisfied_text": "不滿意",
  "chat_feedback_neutral_text": "一般",
  "chat_feedback_satisfied_text": "滿意",
  "chat_feedback_very_satisfied_text": "很滿意",

  "chat_add_friend_fetching_protocol_msg": "正在獲取添加協議",
  "chat_add_friend_copy_success_msg": "複製成功",
  "chat_add_friend_fail_text": "失敗",
  "chat_add_friend_fail_get_number_fail_text": "獲取號碼失敗",
  "chat_add_friend_fail_no_text_selected_text": "沒有選中文字，請手工複製",
  "chat_add_friend_fail_browser_not_support_text": "瀏覽器不支持，請手工複製",
  "chat_change_queue_immediately": "立即切换",
  "chat_close_session_confirm": "結束會話後，重新諮詢可能需要排隊，確認結束會話嗎？",
  "chat_close_session_succ": "會話已結束，如需繼續服務請直接發送消息",

  "chat_incoming": "正在接入，請稍候",
  "chat_incoming_success": "接入成功",
  "chat_incoming_timeout": "接入失敗，請<a class=\"btn-refresh\" href=\"javascript:;\" onclick=\"location.reload();\">重新加載頁面</a>重試",
  "chat_incoming_timeout_inframe": "接入失敗，請重新加載頁面重試",

  // 系统消息
  "sysmsg_load_corpinfo_msg": "正在加載企業信息",
  "sysmsg_load_corpinfo_fail_msg": "企業信息獲取失敗",
  // 员工消息
  "sysmsg_load_staff_msg": "正在加載員工信息",
  "sysmsg_load_staff_fail_msg": "員工信息獲取失敗",

  // 退出排队
  "exit_queque_btn": "退出排隊",
  "exit_queue_confirm": "確認退出當前排隊麼？",
  "exit_queue_success": "你已退出排隊",
  "exit_queue_fail": "退出排隊失敗，請重試",

  // 顶部通知
  "notice_slider_header": "【公告】",
  "notice_popup_header": "企業公告",
  "notice_item_header": "【公告】",
  "notice_item_header_gjh": "【通知】",

  // 电商
  "ec_goods_text": "商品",
  "ec_order_text": "訂單",
};
